// Sentry browser instrumentation. MUST be imported before App.
// DSN comes from REACT_APP_SENTRY_DSN (.env). Safe to expose in client bundle.
import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    // Performance tracing — 10% sample rate to stay within free-tier (5k events/month)
    tracesSampleRate: 0.1,
    // Capture unhandled rejections + global error handler (default true)
    integrations: [Sentry.browserTracingIntegration()],
    // Strip sensitive data before sending to Sentry
    beforeSend(event) {
      // Remove auth headers
      if (event.request?.headers) {
        delete event.request.headers['authorization'];
        delete event.request.headers['Authorization'];
        delete event.request.headers['x-admin-token'];
        delete event.request.headers['X-Admin-Token'];
      }
      // Remove email from user context
      if (event.user) {
        delete event.user.email;
        delete event.user.ip_address;
      }
      // Drop noisy non-actionable errors
      const msg = event.exception?.values?.[0]?.value || '';
      if (
        msg.includes('ResizeObserver loop limit exceeded') ||
        msg.includes('Non-Error promise rejection captured') ||
        msg.includes('Network request failed') ||
        msg.includes('Load failed')
      ) {
        return null;
      }
      return event;
    },
  });
}

export default Sentry;
